
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"30","fill":"#D0DBDB","rx":"2"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M17.412 11.706v1.647m13.176 3.294v1.647M12.471 7.176S17.569 9.396 24 7.154c6.43-2.241 11.53.022 11.53.022v15.692s-5.1-2.264-11.53-.022-11.53.022-11.53.022zM27.294 15c0 2.274-1.475 4.118-3.294 4.118-1.82 0-3.294-1.844-3.294-4.118S22.18 10.882 24 10.882s3.294 1.844 3.294 4.118"}})])
          )
        }
      }
    